import axios from 'axios';

import { useClaim } from '~/components/ClaimContainer';
import type { ClaimConductorAskResponse, RejectConductorAskRequest } from '~/server_shared/openapi/data-contracts';
import { reportAxiosError } from '~/Utils';

/**
 * Rejects a request with the handler's note, which Clive reads on its next run.
 *
 * A failure is reported here and rethrown, so the dialog that took the note stays open with it to
 * retry. The asks are read again either way: a request somebody else closed first settles on its
 * card, behind the dialog, which stays open all the same while the card is listed. The activity
 * panel opens on what needs attention, and there the settled card leaves the list and takes the
 * dialog with it.
 */
export const useRejectRequest = (askId: string, onAskUpdate: () => Promise<void>) => {
  const { claim } = useClaim({ claimRequired: true });

  return async (reason: string): Promise<void> => {
    try {
      await axios.post<ClaimConductorAskResponse>(`/api/v1/claims/${claim.id}/conductor/asks/${askId}/reject`, {
        reason,
      } satisfies RejectConductorAskRequest);
    } catch (error) {
      await reportAxiosError(error);
      throw error;
    } finally {
      await onAskUpdate();
    }
  };
};
